/**
 * Which API paths the gateway answers ONLY on the operator's own Supabase
 * session.
 *
 * Every route on the gateway's `supabase-jwt+admin-role` tier
 * (bicep/07-compute/operations/api-routes.json) runs the fragment
 * `validate-jwt-supabase-with-admin-role.xml`, which accepts the Supabase issuer
 * and nothing else. The firm act-as token (iss `elreign-firm-act`) and the
 * impersonation token are accepted only by the user tier. So a call to one of
 * these paths made on a standing-in token is a 401 before it reaches a handler,
 * every time, and the browser should not send it.
 *
 * That tier is exactly three path prefixes today, and `gateway-tiers.test.ts`
 * reads the manifest and fails the day it is not: a route added to the tier
 * under another prefix, or a route under one of these prefixes moved to the
 * user tier.
 *
 * NEW-R12-MAPSTRUCTURE-ACTAS-401 (grader round 12): the firm console, still
 * mounted while the lazy /app/structure chunk loaded, sent GET /v1/admin/branding
 * and GET /v1/admin/risk-review on the client's act-as token. Both 401.
 */

const OPERATOR_SESSION_ONLY_PREFIXES = [
  '/api/v1/admin/',
  '/api/v1/superadmin/',
  '/api/v1/partner/',
] as const;

/** True when the gateway answers `path` only on the operator's own session. */
export function isOperatorSessionOnlyPath(path: string): boolean {
  const bare = path.split('?')[0] ?? path;
  return OPERATOR_SESSION_ONLY_PREFIXES.some((p) => bare.startsWith(p));
}
